module.exports = __webpack_public_path__ + "img/map_1791552159860_94800.ca1f77ee.jpg";